"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _LoadingButton = _interopRequireDefault(require("./LoadingButton"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DialogBox = ({
  title,
  buttonText,
  isLoading,
  isDialogOpen,
  setIsDialogOpen,
  onOk,
  onCancel,
  children
}) => {
  const handleCancel = () => {
    onCancel();
    setIsDialogOpen(false);
  };
  return isDialogOpen && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "bg-white p-6 rounded-lg shadow-lg w-[32rem]",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
        className: "text-lg mb-4",
        children: title
      }), children, /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex justify-end gap-2 mt-4",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LoadingButton.default, {
          text: buttonText,
          onClick: onOk,
          isLoading: isLoading
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          className: "px-4 py-2 bg-blue-500 rounded text-white",
          onClick: handleCancel,
          children: "Cancel"
        })]
      })]
    })
  });
};
var _default = exports.default = DialogBox;